import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/layout',
    component: () => import('@/pages/Layout'),
    children: [
      {
        path: '/home',
        name: 'home',
        meta: { title: '主页' },
        component: () => import('@/pages/home')
      }
    ]
  }
]

const router = new Router({
  routes: [...routes, {
    path: '*',
    name: '404',
    redirect: '/home',
    component: () => import('@/pages/404')
  }],
  scrollBehavior (to, from, savedPosition) {
    // 期望滚动到哪个的位置
    if (savedPosition) {
      // 返回 savedPosition，在按下 后退/前进 按钮时，就会像浏览器的原生表现那样
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0,
        // 只需将 behavior 选项添加到 scrollBehavior 内部返回的对象中
        // 就可以为支持它的浏览器 (https://developer.mozilla.org/en-US/docs/Web/API/ScrollToOptions/behavior)启用原生平滑滚动
        behavior: 'smooth'
      }
    }
    // 也可以返回一个 Promise 来得出预期的位置描述
    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve({ x: 0, y: 0 })
    //   }, 500)
    // })
  }
})

// 注册一个全局前置守卫
router.beforeEach((to, from, next) => {
  // console.log('router beforeEach', to, from)
  // next(false): 中断当前的导航
  // next(new Error())
  next()
})

// 全局后置钩子 (和守卫不同的是，这些钩子不会接受 next 函数也不会改变导航本身)
router.afterEach((to, from) => {
  // ...
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js